import * as React from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Navbar } from 'components';
import '../src/styles/globals.css';
import { TermsAndCondition } from 'pages/TermsAndCondition';
import { Landing } from 'pages/Landing';

const DApp: React.ComponentType = () => {
	return (
		<Router>
			<div className="atlas-app-shell">
				<div className="atlas-bg-orbs" aria-hidden="true">
					<div className="atlas-bg-orb atlas-bg-orb-one" />
					<div className="atlas-bg-orb atlas-bg-orb-two" />
				</div>
				<div className="atlas-app-content">
					<Navbar />
					<Switch>
						<Route path="/terms-and-condition">
							<TermsAndCondition />
						</Route>
						<Route path="/">
							<Landing />
						</Route>
					</Switch>
				</div>
			</div>
		</Router>
	);
};

export default DApp;
